var _style, _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_more_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_more_svg__st1{fill:currentColor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon_more_svg__st1",
    cx: 8,
    cy: 16,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "icon_more_svg__st1",
    cx: 16,
    cy: 16,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "icon_more_svg__st1",
    cx: 24,
    cy: 16,
    r: 2
  })));
}

export default SvgIconMore;